module.exports = __webpack_public_path__ + "img/image2.eedbe89e.jpg";